import {AsyncPipe} from '@angular/common';
import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {MatCard, MatCardActions, MatCardContent, MatCardHeader, MatCardTitle,} from '@angular/material/card';
import {MatDialog} from '@angular/material/dialog';
import {MatProgressBar} from '@angular/material/progress-bar';
import {MatTooltip} from '@angular/material/tooltip';
import {RouterLink} from '@angular/router';
import {Client, ClientService} from '@app/admin/client.service';
import {StorageDialogComponent} from '@app/admin/storage-dialog/storage-dialog.component';
import {BytesPipe} from '@app/shared/bytes.pipe';
import {Observable} from 'rxjs';

@Component({
    selector: 'frog-content-card',
    templateUrl: './content-card.component.html',
    styleUrls: ['./content-card.component.scss'],
    imports: [
        MatCard,
        MatCardHeader,
        MatCardTitle,
        MatCardContent,
        MatProgressBar,
        MatCardActions,
        MatButton,
        RouterLink,
        MatTooltip,
        AsyncPipe,
        BytesPipe,
    ],
})
export class ContentCardComponent implements OnInit {
    @ViewChild('svg') svg: ElementRef;
    public client$: Observable<Client>;

    constructor(
        private clientService: ClientService,
        private matDialog: MatDialog,
    ) {
        this.client$ = this.clientService.client;
    }

    ngOnInit(): void {}

    edit() {}

    openStorageDialog(clientId: string) {
        const dialog = this.matDialog.open(StorageDialogComponent, {
            width: '600px',
            data: clientId,
        });
        dialog.afterClosed().subscribe((result) => {
            // if (result) {
            //     this.storagePending = true;
            // }
        });
    }
}
